import styled from "styled-components";

import { typography } from "globalConstants";

export type PropsType = any;

const Wrap = styled.div<any>`
   display: block;
   width: 100%;
`;

const TextWrap = styled.div`
   position: relative;
   text-align: center;
   &:before {
      content: "";
      display: inline-block;
      z-index: 0;
      border-radius: 50%;
      background-color: #f8f8f8;
      width: 169px;
      height: 169px;
   }
`;

const Text = styled.div`
   ${typography.other.t1}
   position: absolute;
   left: 50%;
   top: 50%;
   transform: translate(-50%, -50%);
   line-height: 32px;
`;

export default function MoleculeStep4Message(props: PropsType) {
   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <TextWrap>
            <Text>
               기입하신 정보 그대로 등록됩니다. <br />
               전시회 등록을 완료하시겠어요?
            </Text>
         </TextWrap>
      </Wrap>
   );
}
